export enum AdminProgramActivityTemplateTableColumnTitle {
  OrdinalNumber = "Redni broj",
  Name = "Ime",
  DaysDelay = "Odmak u danima",
  RecommendedChannel = "Preporučeni kanal",
  Options = "",
}
